/**
 * A mixin to delete a Campaign, used in the CampaignDetail page.
 *
 * Dialogs must be added to the Campaigndetail page.
 *
 * Depends on:
 *   - this.campaign
 *   - this.loading
 */

var campaignDeletion = {
  data() {
    return {
      deleting: false,
      showDeletionDialog: false,
      deleteCampaignContentsAlso: false,
    };
  },
  computed: {
    deleteCampaignContentsAlsoHint() {
      return `
			  ${this.$t('campaignContentsAffected')}:
			  ${this.campaign.radio_spots.length} ${this.$t('radio')},
			  ${this.campaign.tv_spot_bundles.length} ${this.$t('tv')}
			`;
    },
  },
  methods: {
    deleteCampaign(campaign, withContents) {
      const promise = this.$api.deleteCampaign(campaign.id, withContents);
      promise
        .then(() => {
          this.$bus.$emit('alert-success', {
            message: 'contentDeletedSuccess',
            translate: true,
          });

          // Make sure the drawer items reflect the fact that we may just
          // have deleted the last campaign available to the User (see
          // profile.has_campaigns).
          this.$store.dispatch('RETRIEVE_CURRENT_USER');
        })
        .catch((error) => {
          this.$bus.$emit('alert-error', {
            message: 'genericFailedInfo',
            translate: true,
          });
        })
        .finally(() => {
          // Reset.
          this.deleteCampaignContentsAlso = false;
        });
      return promise;
    },
    onDeleteCampaignConfirmed() {
      this.deleting = true;
      const withContents = this.deleteCampaignContentsAlso;
      this.deleteCampaign(this.campaign, withContents).then(() => {
        this.deleting = false;
        this.showDeletionDialog = false;

        this.$store.commit('RESET_CAMPAIGNS_PAGE_INDEX');
        this.$store.dispatch('LIST_CAMPAIGNS');
        this.$router.push({name: 'campaigns'});
      });
    },
  },
};

export default campaignDeletion;



// WEBPACK FOOTER //
// ./src/mixins/campaignDeletion.js